// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import styles from './radio.module.less';
import {Settings_context} from '../settings_ctx';

interface i_radio_props {
    label: string|JSX.Element;
    on_change: (value:string)=>void;
    value: string;
    checked?: boolean;
    size?: 'sm'|'md';
    color?: 'light';
    name?: string;
    cls?: string;
}

export const Radio = ({label, on_change, value, name, cls, size, color,
    checked}:i_radio_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.hola_radio, size && styles[size],
      color && styles[color], cls, !label && styles.no_label)}>
      <input onChange={e=>on_change(e.target.value)} type="radio" value={value}
        name={name} id={`radio-${value}`} checked={checked}/>
      <label htmlFor={`radio-${value}`}
        className={cn(theme.P, color!='light' && theme.logo_grey)}>
        {label}
      </label>
    </div>;
};
